import PropTypes from "prop-types";
import clsx from "clsx";
import ProductDescriptionInfo from "../../components/product/ProductDescriptionInfo";

const ProductImageDescription = ({
  spaceTopClass,
  spaceBottomClass,
  product,
  sizeData,
}) => {
  return (
    <div
      className={clsx(
        "shop-area product_details_upper_con",
        spaceTopClass,
        spaceBottomClass
      )}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="product-large-image-wrapper">
              <div className="single-image">
                <img
                  src={process.env.REact_APP_IMG_URL + product.ImagePath}
                  alt={product.StyleCode}
                  className="img-fluid"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <ProductDescriptionInfo
              product={product}
              shortDescription="true"
              showBottomContent={true}
              sizeData={sizeData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ProductImageDescription.propTypes = {
  galleryType: PropTypes.string,
  product: PropTypes.shape({}),
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default ProductImageDescription;
